<template>
  <div class="bim-selected-params">
    <div class="top-bar">
      <PageTitle hideMarginLeft>Выбранные БИМ Параметры</PageTitle>
    </div>

    <div class="header">
      <div class="header__info">
        <span class="header__count">Всего выбранных параметров: {{ params.length }}</span>
      </div>
    </div>

    <CustomTable 
      title="Выбранные параметры" 
      :rowsData="params" 
      :columns="columns" 
      :loading="isLoading"
      :small="true"
      :show-search="true"
      :custom-body="true"
      :sticky-header="true"
      :height="300"
    >
      <template #customBody="props">
        <q-tr>
          <custom-table-cell align="center" vertical-align="center" style="width: 100px;">
            {{ props.row.bim_category_id }}
          </custom-table-cell>

          <custom-table-cell align="left" vertical-align="center" style="min-width: 200px;">
            {{ props.row.category_name }}
          </custom-table-cell>

          <custom-table-cell align="center" vertical-align="center" style="width: 100px;">
            {{ props.row.bim_type_id }}
          </custom-table-cell>

          <custom-table-cell align="left" vertical-align="center" style="min-width: 200px;">
            {{ props.row.type_name }}
          </custom-table-cell>

          <custom-table-cell align="left" vertical-align="center" style="min-width: 250px;">
            {{ props.row.param_name }}
          </custom-table-cell>
        </q-tr>
      </template>
    </CustomTable>
  </div>
</template>

<script>
import CustomTable from "@/components/common/CustomTable";
import CustomTableCell from "@/components/common/CustomTable/custom-table-cell";
import PageTitle from "@/components/common/PageTitle.vue";
import { getBimSelectedParams } from "@/views/BimSelectedParams/services";

export default {
  name: "BimSelectedParams",
  components: {
    CustomTable,
    CustomTableCell,
    PageTitle
  },
  data() {
    return {
      params: [],
      isLoading: false,
      columns: [
        {
          name: "bim_category_id",
          field: "bim_category_id",
          label: "ID категории",
          align: "center",
          sortable: true,
          style: "width: 100px",
        },
        {
          name: "category_name",
          field: "category_name",
          label: "Категория",
          align: "left",
          sortable: true,
          style: "min-width: 200px",
        },
        {
          name: "bim_type_id",
          field: "bim_type_id",
          label: "ID типа",
          align: "center",
          sortable: true,
          style: "width: 100px",
        },
        {
          name: "type_name",
          field: "type_name",
          label: "Тип",
          align: "left",
          sortable: true,
          style: "min-width: 200px",
        },
        {
          name: "param_name",
          field: "param_name",
          label: "Параметр",
          align: "left",
          sortable: true,
          style: "min-width: 250px",
        },
      ],
    };
  },
  methods: {
    async loadData() {
      this.isLoading = true;
      const res = await getBimSelectedParams();
      this.isLoading = false;
      if (!res) return;
      this.params = res;
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style scoped lang="scss">
.bim-selected-params {
  padding: 8px;
}

.top-bar {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;

  :deep(.title) {
    margin-bottom: 0 !important;
  }
}

.header {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
  justify-content: space-between;
  align-items: end;

  &__info {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  &__count {
    font-size: 14px;
    color: #666;
    font-weight: 500;
  }
}
</style>

